import { memo, useCallback } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CONTAINER_MIN_HEIGHT = 320;
const CONTAINER_STYLE = { minHeight: CONTAINER_MIN_HEIGHT };

interface ConfirmationStepProps {
  selectedMembership: string;
  isAnnualMembership: "monthly" | "annual";
  membershipPrice?: number;
  discountCode?: string;
}

function ConfirmationStepInner({
  selectedMembership,
  isAnnualMembership,
  membershipPrice = 0,
  discountCode,
}: ConfirmationStepProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleProceed = useCallback(() => {
    navigate("/dashboard");
  }, [navigate]);

  const promo = (discountCode || "").trim();

  return (
    <div
      className="d-flex flex-column gap-4 p-4 rounded-4 bg-white"
      style={CONTAINER_STYLE}
    >
      <div className="text-center">
        <h4 className="fw-bold mb-3">{t("membership.confirmation.title")}</h4>
        <p className="text-muted">
          {t("membership.confirmation.purchaseSummary", {
            membership: selectedMembership,
          })}
        </p>
      </div>

      <hr />

      <div className="d-flex justify-content-between px-2">
        <span className="fw-medium">
          {(isAnnualMembership === "annual"
            ? t("checkout.annual")
            : t("checkout.monthly")) +
            " " +
            selectedMembership}
          :
        </span>
        <span className="fw-bold">£{membershipPrice.toFixed(2)}</span>
      </div>
      {promo && (
        <>
          <div className="d-flex justify-content-between px-2">
            <span className="fw-medium">{t("membership.discountCode")}</span>
            <span className="fw-bold">{promo}</span>
          </div>
          <p className="small text-muted px-2 mb-0">
            {t("membership.confirmation.pricingNote")}
          </p>
        </>
      )}
      <hr />
      <p className="text-center mb-0">{t("membership.confirmation.completeProfile")}</p>
      <Button className="m-auto px-5" onClick={handleProceed}>
        {t("contact.confirmation.goDashboard")}
      </Button>
    </div>
  );
}

ConfirmationStepInner.displayName = "ConfirmationStep";

const ConfirmationStep = memo(ConfirmationStepInner);
ConfirmationStep.displayName = "ConfirmationStep";

export default ConfirmationStep;
